import { AccountMeta, PublicKey } from "@solana/web3.js";
import { Account, Identity, Profile, ReputationManager, User } from "align-sdk";
import BN from "bn.js";

export interface UserInfo {
    profile: Account<User>,
    identity: Account<Identity>,
    reputation: Account<ReputationManager>,
    linkedWallets: string[]
}

export type RawInstructionData = Buffer
export type RawInstructionKeys = AccountMeta[]
export type InstructionArg = Record<string, number | Uint8Array | BN | string>
export type InstructionKeys = Record<string | number, AccountMeta | AccountMeta[]>

export enum ParseTransactionTypes {
    TokenTransfer,
    JupiterSwap,
    NativeTransfer,
    CreateProfile,
    SetProfile,
    CreateWalletTracker,
    TrackPfp,
    AddCouncilMember,
    RemoveCouncilMember,
    SetWalletThreshold,
    CreateAtaIdempotent,
    Unknown
}

export interface ParsedProposalInstruction {
    [x: string]: any;
    type: ParseTransactionTypes,
    data: InstructionArg | RawInstructionData,
    keys: InstructionKeys | RawInstructionKeys,
    programId: PublicKey
}


export type ContributionRecordDto = { __typename?: 'ContributionRecordDto', address: string, isClaimed: boolean, upVoteCount: any, downVoteCount: any }
export type CouncilVoteRecordDto = {
    __typename?: "CouncilVoteRecordDto" | undefined;
    vote: string;
    address: string;
    review_score?: number | null | undefined;
    id: string;
    user: {
        __typename?: "ProfileDto" | undefined;
        username: string;
        displayName: string;
        userIdentityAddress: string;
        pfp?: string | null | undefined;
    };
}

export type CouncilVote = "Yes" | "No" | "Abstain" | "None"

export type ProfileDto = { __typename?: 'ProfileDto', pfp?: string | null, userIdentityAddress: string, username: string, displayName: string }

export type WalletConfigDto = {
    __typename?: "WalletDto" | undefined;
    walletAddress: string;
    address: string;
    votingProposalCount: number;
    name: string;
    threshold: number;
    totalProposals: any;
}

export type Comment = { 
    __typename?: 'CommentDto', 
    id: string, 
    comment: string, 
    upvotes: number, 
    votesTotal: number, 
    downvotes: number, 
    created_at: string, 
    proposalAddress: string, 
    user: {
         __typename?: 'UserDto', 
         userIdentityAddress?: string | null, 
         pfp?: string | null, 
         username: string, 
         displayName: string 
        }, 
    parent?: { 
        __typename?: 'CommentDto', 
        id: string 
    } | null, 
    children: {
        __typename?: 'CommentDto', 
        id: string, 
        comment: string, 
        upvotes: number, 
        votesTotal: number, 
        downvotes: number, 
        created_at: string, 
        proposalAddress: string, 
        user: {
             __typename?: 'UserDto', 
             userIdentityAddress?: string | null, 
             pfp?: string | null, 
             username: string, 
             displayName: string 
            }, 
        parent?: { 
            __typename?: 'CommentDto', 
            id: string } | null, 
        childrenCount: number,
        children: {
            __typename?: 'CommentDto', 
            id: string, 
            comment: string, 
            upvotes: number, 
            votesTotal: number, 
            downvotes: number, 
            created_at: string, 
            proposalAddress: string, 
            user: {
                 __typename?: 'UserDto', 
                 userIdentityAddress?: string | null, 
                 pfp?: string | null, 
                 username: string, 
                 displayName: string 
                }, 
            parent?: { 
                __typename?: 'CommentDto', 
                id: string } | null, 
            childrenCount: number,
            
            }[]
        }[],
        
    }
    